import React from 'react';
import { layout, palette, typography } from '@citrite/web-ui-component';
import styled from '@emotion/styled';
import { FeatureFlag } from 'Environment/FeatureFlag';
import { useFeatureCanary } from 'utils/useFeatureCanary';
import { useLoadableResourceContext } from 'Workspace/ResourceProvider';

const StyledMessageSpanLegacy = styled.span`
	font-size: ${typography.sizes.xsml};
	font-weight: ${typography.weights.regular};
	color: ${palette.grey900};
	padding: 4px 4px 0 0;
	height: ${layout.space12};
`;

const StyledMessageSpanDetailed = styled(StyledMessageSpanLegacy)`
	padding: unset;
`;

export const ServerName = () => {
	const resourceContext = useLoadableResourceContext()?.value;
	const serverName = resourceContext?.serverName;
	const isCenterAlignClassicViewEnabled = useFeatureCanary(
		FeatureFlag.CenterAlignClassicView
	);
	const StyledMessageSpan = isCenterAlignClassicViewEnabled
		? StyledMessageSpanDetailed
		: StyledMessageSpanLegacy;
	return <StyledMessageSpan>{serverName}</StyledMessageSpan>;
};
